import { render, staticRenderFns } from "./TXTransactionReport.vue?vue&type=template&id=e8f6c12c"
import script from "./TXTransactionReport.vue?vue&type=script&lang=js"
export * from "./TXTransactionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports